import type { QueryClient } from '@tanstack/react-query';
import type { PilotContextResponse, PilotPractice } from '@wundo/shared/pilotContext.ts';
import { apiFetchJson } from './api.ts';

export type { PilotContextResponse, PilotPractice };

/** Null is the ordinary answer: most people are not in a pilot. */
export const PILOT_CONTEXT_KEY = ['pilotContext'] as const;

export async function fetchPilotContext(): Promise<PilotContextResponse | null> {
  return apiFetchJson<PilotContextResponse | null>('/users/me/pilot');
}

/**
 * The pilot decides where somebody lands and how many dots the wizard draws,
 * so a route that acts on it reads it in its loader rather than in a component:
 * a page that renders first and redirects afterwards shows the wrong screen for
 * a frame, which is exactly what onboarding cannot afford.
 */
export function ensurePilotContext(
  queryClient: QueryClient,
): Promise<PilotContextResponse | null> {
  return queryClient.ensureQueryData({
    queryKey: PILOT_CONTEXT_KEY,
    queryFn: fetchPilotContext,
  });
}
